module.exports = __webpack_public_path__ + "img/coolcreative.84afc48b.jpg";